import React, { useEffect, useState } from "react";
import Modal from "../../../components/modal";
import axios from "axios";
import Swal from "sweetalert2";
import { API_URL } from "../../../utils/constant";

const CompanyMetalRateModal = ({
  show,
  onClose,
  heading,
  initialData,
  onSuccess,
}) => {
  const [formData, setFormData] = useState({
    company_id: localStorage.getItem("companyID"),
    gold: "",
    silver: "",
    effective_from: "",
  });

  useEffect(() => {
    if (initialData) {
      setFormData({
        company_id: initialData.company_id,
        gold: initialData.gold,
        silver: initialData.silver,
        effective_from: initialData.effective_from,
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (initialData?.id) {
        await axios.put(
          `${API_URL}/company-metal-rates/${initialData.id}`,
          formData
        );
        Swal.fire("Success", "Metal rate updated successfully", "success");
      } else {
        await axios.post(`${API_URL}/company-metal-rates`, formData);
        Swal.fire("Success", "Metal rate added successfully", "success");
      }

      onClose();
      onSuccess();
    } catch (error) {
      Swal.fire(
        "Error",
        error.response?.data?.message || "Something went wrong",
        "error"
      );
    }
  };

  return (
    <Modal show={show} onClose={onClose} heading={heading}>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Gold Rate</label>
            <input
              type="number"
              step="0.01"
              className="form-control"
              name="gold"
              value={formData.gold}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-6 mb-3">
            <label className="form-label">Silver Rate</label>
            <input
              type="number"
              step="0.01"
              className="form-control"
              name="silver"
              value={formData.silver}
              onChange={handleChange}
              required
            />
          </div>

          <div className="col-md-12 mb-3">
            <label className="form-label">Effective From</label>
            <input
              type="date"
              className="form-control"
              name="effective_from"
              value={formData.effective_from}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="d-flex justify-content-end">
          <button
            type="button"
            className="btn btn-light me-2"
            onClick={onClose}
          >
            Cancel
          </button>
          <button type="submit" className="btn btn-primary">
            Save
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default CompanyMetalRateModal;
